import type { App } from 'vue'

import Blank from './Blank.vue'
import Default from './Default.vue'

export const registerLayouts = (app: App<Element>) => {
    app.component('Blank', Blank)
    app.component('Default', Default)
}
